// extracted by mini-css-extract-plugin
export default {"container":"SongFeelsHeader_container__XXHjM","text":"SongFeelsHeader_text__6eExM"};